import React, { useState } from 'react';

import { iRootState } from '../../store';
import { RouteComponentProps } from 'react-router-dom';
import { FormikProps } from 'formik';

import Filter from './components/Filter/Filter';
import List from './components/List/List';
import { FilterData } from './types';

const mapState = (state: iRootState) => ({
  availableBrokersAndEstates: state.availableBrokersAndEstates,
  user: state.user
});

export type Props = ReturnType<typeof mapState> &
  RouteComponentProps &
  FormikProps<FilterData>;

const Financial = (props: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<any>(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  return (
    <>
      <Filter
        {...props}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        data={data}
        setData={setData}
        page={page}
        setPage={setPage}
        total={total}
        setTotal={setTotal}
      />
      <List
        {...props}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        data={data}
        page={page}
        setPage={setPage}
        total={total}
      />
    </>
  );
};

export default Financial;
